import { useRoute } from '@react-navigation/native';
import { useLocalSearchParams } from 'expo-router';

/**
 * Retrieves route params safely across both React Navigation and expo-router.
 *
 * Tries `useRoute().params` from `@react-navigation/native` first, then
 * falls back to `useLocalSearchParams()` from `expo-router`.
 */
export const useSafeRouteParams = <
  T extends Record<string, string | string[] | undefined>,
>(): T => {
  try {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { params } = useRoute();

    return (params ?? {}) as T;
  } catch {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return useLocalSearchParams() as T;
  }
};
